import AppDispatcher from "../../../flux/dispatcher/dispatcher";
// import AppDispatcher from 'dispatcher/dispatcher';
import Constant from "../constant/Constants";
import restClient from "../../MainFrame/action/APIClient";
import LogoutConstant from "../../MainFrame/constants/Constants";
var _ = require("lodash");

var GetLocationInsightMetricCountAction = function () {};

GetLocationInsightMetricCountAction.prototype = {
	getData: function (data) {
		data['filters']['insightFilters'] = {
			"metrics": [
				"VIEWS_MAPS",
				"VIEWS_SEARCH",
				'BUSINESS_IMPRESSIONS_DESKTOP_MAPS',
				'BUSINESS_IMPRESSIONS_MOBILE_MAPS',
				'BUSINESS_IMPRESSIONS_MOBILE_SEARCH',
				'BUSINESS_IMPRESSIONS_DESKTOP_SEARCH',
			]
		}
		restClient.getLocationInsightMetricCount(data, function (error, response) {
			if (error) {
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error,
					});
				} else {
					AppDispatcher.dispatch({
						actionType: Constant.GET_LOCATION_INSIGHT,
						data: error,
					});
				}
			} else if (response != null) {
				AppDispatcher.dispatch({
					actionType: Constant.GET_LOCATION_INSIGHT,
					data: response,
				});
			}
		});
	},
};

export default new GetLocationInsightMetricCountAction();
